import './Home.css';
import Navbar from './components/Navbar';
import IntroCurtain from './components/IntroCurtain';
import ScrollProgress from './components/ScrollProgress';
import CursorGlow from './components/CursorGlow';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Clients from './components/Clients';
import Services from './components/Services';
import Process from './components/Process';
import WhyUs from './components/WhyUs';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import useSiteMotion from './useSiteMotion';

function Home() {
  useSiteMotion();

  return (
    <div className="page">
      <IntroCurtain />
      <ScrollProgress />
      <CursorGlow />
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Process />
      <WhyUs />
      <Clients />
      <Faq />
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
